import { BoardParticipant, Partner } from 'types';
import { getPartnerActualShares } from 'utils/filters';

type Props = {
  participant: BoardParticipant;
  partners: Partner[];
  allParticipants: boolean;
};

const isRepresentedButNotDelegated = (participant: BoardParticipant) =>
  participant?.isRepresented && !participant.hasDelegated;

const isNotAssistingNorAbsentNorDelegated = (participant: BoardParticipant) =>
  !participant?.assists && !participant?.isAbsent && !participant?.hasDelegated;

export const isParticipantAllowedForReminder = ({
  participant,
  partners,
  allParticipants,
}: Props) => {
  const participantShares = getPartnerActualShares(
    participant.member,
    partners
  );

  if (participantShares === 0) return false;

  if (allParticipants) return true;

  return (
    isRepresentedButNotDelegated(participant) ||
    isNotAssistingNorAbsentNorDelegated(participant)
  );
};
